import { memo, useEffect, useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

const CDN = 'https://wver.sprintstaticdata.com/v230/static/front/img/cards';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function bookOf(exposures, nat) {
  return roundBook(exposures?.[nat] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

const ODD_VALS = ['A', '3', '5', '7', '9'];
const EVEN_VALS = ['2', '4', '6', '8', '10'];
const LOW_VALS = ['A', '2', '3', '4', '5'];
const HIGH_VALS = ['6', '7', '8', '9', '10'];
const CARD_GRID_VALS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

function CardImgRow({ vals }) {
  return (
    <div className="d-flex">
      {vals.map((v) => (
        <div key={v} className="card-image ml-1">
          <img src={`${CDN}/single/${v}.jpg`} />
        </div>
      ))}
    </div>
  );
}

// Note Number — table note. Odd/Even/Black/Red/Low/High (back+lay) with sample
// card images; Baccarat 1/2 (back only); 10-card grid (A-10) with per-card odds
// + book. Web = row5 col-4 (d-none-small), mobile = row5 casino-bl-box stack
// (d-none-big). book-black hamesha. Images CDN se.
const BetTableNoteNum = memo(function BetTableNoteNum({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const odd = sub.find((s) => s.subtype === 'odd');
  const even = sub.find((s) => s.subtype === 'even');
  const black = sub.find((s) => s.subtype === 'black');
  const red = sub.find((s) => s.subtype === 'red');
  const low = sub.find((s) => s.subtype === 'low');
  const high = sub.find((s) => s.subtype === 'high');
  const baccItems = sub.filter((s) => s.subtype === 'bacc');
  const bacc1 = baccItems[0] || null;
  const bacc2 = baccItems[1] || null;
  const cardItem = sub.find((s) => s.subtype === 'card');
  const cardOdds = cardItem?.odds || [];

  // web col: label/suit + back/lay + book (casino-nation-name book-black)
  const webBook = (item) => {
    const v = bookOf(exposures, item?.nat);
    return <div className={`casino-nation-name ${bookCls(v)}`}>{fmtBook(v)}</div>;
  };

  const webBackLay = (item) => (
    <div className="casino-bl-box">
      <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
        <span className="casino-box-odd">{item?.b || 0}</span>
      </div>
      {' '}
      <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
        <span className="casino-box-odd">{item?.l || 0}</span>
      </div>
    </div>
  );

  // web value-card column (Odd/Even/Low/High)
  const webValCol = (item, label, vals) => (
    <div className="col-4 oe-cards">
      <div className="casino-box-row">
        <div className="casino-nation-name">
          <b>{item?.nat || label}</b>
          {' '}
          <CardImgRow vals={vals} />
        </div>
        {' '}
        {webBackLay(item)}
        {' '}
        {webBook(item)}
      </div>
    </div>
  );

  // web suit column (Black/Red)
  const webSuitCol = (item, imgs) => (
    <div className="col-4">
      <div className="casino-box-row">
        <div className="casino-nation-name">
          <div className="casino-card-img">
            <span>
              <img src={`${CDN}/${imgs[0]}.png`} />
              {' '}
              <img src={`${CDN}/${imgs[1]}.png`} />
            </span>
          </div>
        </div>
        {' '}
        {webBackLay(item)}
        {' '}
        {webBook(item)}
      </div>
    </div>
  );

  // mobile row: odds-name (label/suit + book) + back + lay
  const mobBook = (item) => {
    const v = bookOf(exposures, item?.nat);
    return <span className={`text-left w-100 ${bookCls(v)}`}>{fmtBook(v)}</span>;
  };

  const mobValRow = (item, label, vals) => (
    <div className="casino-bl-box oe-cards">
      <div className="casino-bl-box-item casino-odds-name">
        <b>{item?.nat || label}</b>
        {' '}
        <CardImgRow vals={vals} />
        {' '}
        {mobBook(item)}
      </div>
      {' '}
      <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
        <span className="casino-box-odd">{item?.b || 0}</span>
      </div>
      {' '}
      <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
        <span className="casino-box-odd">{item?.l || 0}</span>
      </div>
    </div>
  );

  const mobSuitRow = (item, imgs) => (
    <div className="casino-bl-box">
      <div className="casino-bl-box-item casino-odds-name">
        <div className="casino-card-img">
          <span>
            <img src={`${CDN}/${imgs[0]}.png`} />
            {' '}
            <img src={`${CDN}/${imgs[1]}.png`} />
          </span>
        </div>
        {' '}
        {mobBook(item)}
      </div>
      {' '}
      <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
        <span className="casino-box-odd">{item?.b || 0}</span>
      </div>
      {' '}
      <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
        <span className="casino-box-odd">{item?.l || 0}</span>
      </div>
    </div>
  );

  // baccarat back-only row (odd + book)
  const baccRow = (item, label, hint) => {
    const v = bookOf(exposures, item?.nat);
    return (
      <div className="casino-box-row">
        <div className="casino-nation-name">
          <b>{label}</b>
          {' '}
          <span className="text-yellow">{hint}</span>
        </div>
        {' '}
        <div className="casino-bl-box">
          {/* With a book, a locked cell pins its padlock to the TOP (lock-top) so
              the liability stays readable — same as the player site / Dus ka Dum. */}
          <div className={`back casino-bl-box-item${v ? ' lock-top' : ''}${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
            <span className="casino-box-odd">{item?.b || 0}</span>
            {' '}
            <span className={bookCls(v)}>{fmtBook(v)}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Desktop / Mobile: only one in the DOM at a time (reference v-if) */}
      {!isMobile && (<div className="container-fluid container-fluid-5">
        <div className="row row5 d-none-small">
          {webValCol(odd, 'Odd Card', ODD_VALS)}
          {' '}
          {webSuitCol(black, ['spade', 'club'])}
          {' '}
          {webValCol(low, 'Low Card', LOW_VALS)}
          {' '}
          {webValCol(even, 'Even Card', EVEN_VALS)}
          {' '}
          {webSuitCol(red, ['heart', 'diamond'])}
          {' '}
          {webValCol(high, 'High Card', HIGH_VALS)}
        </div>
      </div>)}

      {isMobile && (<div className="container-fluid container-fluid-5">
        <div className="row row5 d-none-big">
          {mobValRow(odd, 'Odd Card', ODD_VALS)}
          {' '}
          {mobValRow(even, 'Even Card', EVEN_VALS)}
          {' '}
          {mobSuitRow(black, ['spade', 'club'])}
          {' '}
          {mobSuitRow(red, ['heart', 'diamond'])}
          {' '}
          {mobValRow(low, 'Low Card', LOW_VALS)}
          {' '}
          {mobValRow(high, 'High Card', HIGH_VALS)}
        </div>
      </div>)}

      {/* Baccarat + Card grid (shared) */}
      <div className="container-fluid container-fluid-5">
        <div className="row row5">
          <div className="col-md-4 col-12 note-baccarat">
            {baccRow(bacc1, 'Baccarat 1', '(1st, 2nd, 3rd card)')}
            {' '}
            {baccRow(bacc2, 'Baccarat 2', '(4th, 5th, 6th card)')}
          </div>
          {' '}
          <div className="col-md-8 col-12 note-cards">
            <div className="casino-cards text-center mt-1">
              {CARD_GRID_VALS.map((val, i) => {
                const oddsEntry = cardOdds.find((o) => o.sno === i + 1) || cardOdds[i] || null;
                const susp = isSusp(cardItem) || !oddsEntry;
                const cardOdd = oddsEntry?.b ?? 0;
                // Card bets are keyed "<live Card N> <val>" (NoteNumber page) — the odds
                // entry's own nat ("Card A", "Card 6") never matched a bet.
                const v = bookOf(exposures, cardItem?.nat ? `${cardItem.nat} ${val}` : '');
                return (
                  <div
                    key={val}
                    className="casino-card-item"
                    onClick={susp ? undefined : () => handleBet(cardItem.sid, 'back', cardOdd, { ...oddsEntry, nat: oddsEntry?.nat || `Card ${val}` })}
                  >
                    <div className="casino-book">{cardOdd}</div>
                    {' '}
                    <div className={`card-image${susp ? ' suspended' : ''}`}>
                      <img src={`${CDN}/${val}.png`} />
                    </div>
                    {' '}
                    <div className={bookCls(v)}>{fmtBook(v)}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default BetTableNoteNum;
